<template>
	<div :class="'question-container ' + questionKey">
		<div>
			<div
				class="question-text"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div :class="questionKey + ' ' + data.question.cssClass + ' multi-button-answer'">
				<button
					class="button"
					v-for="answer in buttons"
					:key="answer.button.label"
					:style="{
						borderRadius: '0',
						border: '1px solid ' + theme[answer.button.style.background],
						background: answer.selected ? theme[answer.button.style.background] : 'none',
						color: answer.selected ? theme['altTextColor'] : theme[answer.button.style.background],
					}"
					@click="toggleSelection(answer)"
				>
					<i
						v-if="answer.selected"
						class="far fa-check-square"
					></i>
					<i
						v-else
						class="far fa-square"
					></i>
					{{ localization.buttonLabels[answer.button.label][data.language] }}
				</button>
			</div>
		</div>
		<div class="fixed-bottom">
			<div class="question-continue-button">
				<button
					class="button continue-multi-select"
					:style="{
						border: '1px solid ' + theme[continueBtn.style.background],
						background: theme[continueBtn.style.background],
						color: theme[continueBtn.style.text],
					}"
					@click="continueBtn.actions(selectedValues, [], data.question, toggleLoading, saveApplicationAction)"
					:disabled="isContinueDisabled()"
				>
					{{ data.question.getLocalizationDisplay(continueBtn.label, data.language) }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import LOCALIZATION from '@core/classes/Localization';
	import { required, minLength, between } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'QuestionMultiSelect',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				answer: null,
				continueBtn: null,
				buttons: [],
				selectedValues: [],
			};
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
		},
		created() {
			this.data.question.getAnswers().forEach(a => {
				if (a.label == 'continue') {
					this.continueBtn = a;
				} else {
					this.buttons.push({ selected: false, button: a });
				}
			});
			if (this.data.question.savedAnswer && this.data.question.savedAnswer.length != 0) {
				this.buttons.forEach(b => {
					if (this.data.question.savedAnswer.includes(b.button.label)) {
						b.selected = true;
					}
				});
			}
			if (this.data.question.savedAnswer && this.data.question.savedAnswer.length != 0) {
				this.selectedValues = this.data.question.savedAnswer;
			}
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
				},
				{ deep: true },
			);
		},

		methods: {
			toggleSelection(obj) {
				obj.selected = !obj.selected;
				this.selectedValues = this.buttons.filter(b => b.selected).map(b => b.button.label);
			},
			isContinueDisabled() {
				if (this.continueBtn.isValidationRequired) {
					return this.selectedValues.length == 0;
				}
				return false;
			},
		},
		components: {},
	};
</script>

<style>
	.multi-button-answer i {
		margin-right: 5px;
	}

	.two-columns button {
		width: 200px;
	}
</style>
